import { useQuery } from '@tanstack/react-query';
import { fetchUserContext } from '../lib/api';

export function usePermissions() {
  const query = useQuery({
    queryKey: ['user-context'],
    queryFn: fetchUserContext,
    staleTime: 5 * 60_000,
    retry: 1,
  });

  const role = query.data?.role || 'viewer';
  const permissions = new Set(query.data?.permissions || []);

  return {
    role,
    permissions,
    isAdmin: role === 'admin',
    isManager: role === 'manager' || role === 'admin',
    canCreate: permissions.has('create'),
    canUpdate: permissions.has('update'),
    canDelete: permissions.has('delete'),
    canExport: permissions.has('export'),
    canManageIntegrations: permissions.has('manage_integrations'),
    canSyncIntegrations: permissions.has('sync_integrations'),
    canManageUsers: permissions.has('manage_users'),
    canViewAudit: permissions.has('view_audit'),
    /** ADR 0003: associate a HubSpot deal with a company, written in HubSpot. */
    canAssociateHubspotCompany: permissions.has('write_hubspot_association'),
    /** ADR 0004: create a HubSpot company from a client file. */
    canCreateHubspotCompany: permissions.has('create_hubspot_company'),
    isLoading: query.isLoading,
  };
}
